var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLaptop = function SvgLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.922 14.5H1.077a1.052 1.052 0 0 1-.96-1.534l.86-1.7V3.5a2 2 0 0 1 2.011-2h10.034a2.006 2.006 0 0 1 2.01 2v7.767l.85 1.7a1.05 1.05 0 0 1-.96 1.533Zm-1.92-11H2.998v6h10.004v-6Zm-.1 8H3.108l-.5 1h10.794l-.5-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgLaptop;